import Layout from "@/layouts/default/main"
export default {
    path: "/app",
    name: "App",
    redirect: "/app/index",
    component: Layout,
    children: [{
        path: "index",
        name: "AppIndex",
        component: () => import("@/views/app/index")
    }]
}